import { observable } from "mobx";
import { settingService } from "../_services";
import { ISetting } from "../_types/interfaces";
import i18n from 'i18next';

const translate = (name: string) => i18n.t('setting.' + name);


export const settingDownloadStore = observable({
    loading: false,
    setting: { 
        OfflineInstall: false, 
        TimeSleap: "3", 
        TypeTime: "минута", 
        ServerAddress: "http://84.201.169.119:18080"
    } as ISetting,
    isNotification: false,
    massTypeTime : [
        "минута",
        "час",
        "день"],
    indexItem: -1,
    message: "",
    showMessage(message: string) {
        settingDownloadStore.message = message;
        settingDownloadStore.isNotification = true;
    },
    async loadSettings() {
        settingDownloadStore.loading = true;
        try {
            const response = await settingService.getSettings();
            settingDownloadStore.setting = response;
            settingDownloadStore.indexItem = settingDownloadStore.massTypeTime.indexOf(response.TypeTime)
        }
        catch (errors) {
            settingDownloadStore.showMessage(translate('notification.load_error'));
        }
        settingDownloadStore.loading = false;
    },
    async updateSetting() {
        settingDownloadStore.loading = true;
        try {
            if(Number(settingDownloadStore.setting.TimeSleap) == 0)
            {
                throw("notification.incorrect_data");
            }
            settingDownloadStore.setting.TypeTime = settingDownloadStore.massTypeTime[settingDownloadStore.indexItem];
            await settingService.updateSettings(settingDownloadStore.setting);
            settingDownloadStore.showMessage(translate('notification.download_ok'));
        }
        catch (errors) {
            settingDownloadStore.showMessage(translate('notification.download_error'));
            console.log(errors);
        }
        settingDownloadStore.loading = false;
    },
})